export let cookieConsent = (() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
    var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
    var __commonJS = (cb, mod) => function __require() {
        return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    };
  var __reExport = (target, module, copyDefault, desc) => {
        if (module && typeof module === "object" || typeof module === "function") {
      for (let key of __getOwnPropNames(module))
                if (!__hasOwnProp.call(target, key) && (copyDefault || key !== "default"))
                    __defProp(target, key, { get: () => module[key], enumerable: !(desc = __getOwnPropDesc(module, key)) || desc.enumerable });
    }
    return target;
  };
  var __toESM = (module, isNodeMode) => {
        return __reExport(__markAsModule(__defProp(module != null ? __create(__getProtoOf(module)) : {}, "default", !isNodeMode && module && module.__esModule ? { get: () => module.default, enumerable: true } : { value: module, enumerable: true })), module);
  };

  // src/texts.js
  var require_texts = __commonJS({
    "src/texts.js"(exports, module) {
      module.exports = Object.freeze({
        descriptions: {
          usage:
            "Vallentuna kommun anv\xE4nder kakor f\xF6r att ge dig b\xE4sta m\xF6jliga upplevelse p\xE5 v\xE5r webbplats, till exempel f\xF6r att anpassa inneh\xE5ll och annonser, tillhandah\xE5lla funktioner f\xF6r sociala medier och f\xF6r att analysera webbtrafiken. F\xF6r b\xE4sta anv\xE4ndarupplevelse rekommenderar vi att du aktiverar alla kakor, men du kan ocks\xE5 anpassa inst\xE4llningarna efter dina behov.",
          description:
            "En del kakor \xE4r n\xF6dv\xE4ndiga f\xF6r att webbplatsen ska fungera, medan andra ger dig ytterligare funktionalitet och inneh\xE5ll. Du best\xE4mmer vilka kakor du vill godk\xE4nna och kan \xE4ndra dina inst\xE4llningar n\xE4r som helst.",
          required:
            "Dessa kakor beh\xF6vs f\xF6r att v\xE5r webbplats ska fungera och de kan inte st\xE4ngas av i v\xE5ra system. De lagras vanligtvis endast som svar p\xE5 \xE5tg\xE4rder du vidtar, som inneb\xE4r en beg\xE4ran om tj\xE4nster, som t.ex. att g\xF6ra integritetsinst\xE4llningar, logga in eller fylla i formul\xE4r. Du kan st\xE4lla in din webbl\xE4sare s\xE5 att den blockerar eller varnar dig om dessa kakor, men d\xE5 kommer vissa delar av webbplatsen inte att fungera. Dessa kakor lagrar ingen information som identifierar dig som person.",
          performance:
            "Dessa kakor g\xF6r att vi kan r\xE4kna bes\xF6kare och trafikk\xE4llor s\xE5 att vi kan m\xE4ta och f\xF6rb\xE4ttra prestandan p\xE5 v\xE5r webbplats. De hj\xE4lper oss att ta reda p\xE5 vilka sidor som \xE4r mest och minst popul\xE4ra och se hur bes\xF6kare navigerar omkring p\xE5 webbplatsen. All information som dessa kakor samlar in \xE4r sammantagen och d\xE4rf\xF6r anonym. Om du inte till\xE5ter dessa kakor kommer vi inte veta n\xE4r du har bes\xF6kt v\xE5r webbplats och vi kan inte \xF6vervaka dess prestanda.",
          functional:
            "Dessa kakor ger webbplatsen m\xF6jlighet att tillhandah\xE5lla f\xF6rb\xE4ttrad funktionalitet och personlig anpassning. De kan lagras av oss eller av tredjepartsleverant\xF6rer vars tj\xE4nster vi har lagt till p\xE5 v\xE5ra sidor. Syftet med dessa kakor \xE4r att ge dig en mer personligt anpassad upplevelse p\xE5 v\xE5r webbplats baserat p\xE5 dina tidigare bes\xF6k och val. Om du inte till\xE5ter dessa kakor kan det h\xE4nda att vissa eller inga av dessa tj\xE4nster fungerar som de ska.",
            recommended:
            "Dessa kakor ger dig möjlighet att få förslag på relevant innehåll och ett mer träffsäkert sökresultat.",
            marketing:
            "Dessa kakor ger information om hur webbplatsen anv\xE4nds och hj\xE4lper oss att f\xF6rb\xE4ttra anv\xE4ndarupplevelsen.",
        },
        cookieDescriptions: {
          required: "Acceptera n\xF6dv\xE4ndiga kakor",
          performance: "Acceptera prestanda kakor",
          marketing: "Acceptera cookies f\xF6r statistik och utv\xE4rdering",
          functional: "Acceptera funktionella kakor",
          recommended: "Acceptera rekommenderade kakor",
        },
        btnAccept: "Acceptera rekommenderade inst\xE4llningar",
        btnCustomize: "Anpassa inst\xE4llningar",
        btnSaveCustom: "Spara",
        customizeHeader: "Anpassa inst\xE4llningar f\xF6r kakor"
      });
    }
  });

  // src/index.js
  var require_src = __commonJS({
    "src/index.js"(exports, module) {
      var import_texts = __toESM(require_texts());
      var _args = {};
      var _workingElement = null;
      var _choices = {};
      var _consentGiven = false;
      var _text = {};
      var createWorkingElement = () => {
        let workingElement = document.getElementById(_args.target);
        if (!workingElement) {
          workingElement = document.createElement("div");
          //workingElement.id = _args.target;
          document.body.append(workingElement);
        }
        workingElement.classList.add("CookieConsent");
        _workingElement = workingElement;
      };
      var populatePopup = () => {
        document.body.classList.add('overflow-hidden');
        const innerMarkup = `
        <div class="backdrop">
          <div class="cookie-modal" role="dialog" aria-label="Information om kakor" autoFocus>
            <header>${_text.customizeHeader}</header>
            <p>${_text.descriptions.usage}</p>
            <div class="buttons">
              <button class="button" id="btnAcceptDefault">${_text.btnAccept}</button>
              <button class="button button-blue" id="btnCustomizeConsent">${_text.btnCustomize}</button>
            </div>
          </div>
        </div>
      `;
        _workingElement.innerHTML = innerMarkup;
      };
      var customizeConsent = () => {
        const CategoryMarkup = _args.categories.map((c) => {
          const selection = _choices[c.type];
          return `
      <fieldset>
        <legend>${c.description}</legend>
        <p>${_text.descriptions[c.type]}</p>
        <input id="type-${c.type}" 
          class="form-check-input" name="type-${c.type}"
          type="checkbox" ${c.type == "required" ? 'disabled checked="true"' : ""} 
          ${selection == "true" ? "checked='true'" : ""}>
        <label for="type-${c.type}">
          ${_text.cookieDescriptions[c.type]}
        </label>
      </fieldset>`;
        });
        const innerMarkup = `
    <div class="backdrop">
      <div class="cookie-modal" role="dialog" aria-label="Anpassa inst\xE4llningar" autoFocus>
        <header>${_text.customizeSettingsHeader}</header>
        <p>${_text.descriptions.description}</p>
        ${CategoryMarkup.join("")}
        <div class="buttons">
          <button class="button" id="btnSaveCustom">${_text.btnSaveCustom}</button>
          <button class="button button-blue" onclick="" id="btnCustomAcceptDefault">${_text.btnAccept}</button>
        </div>
      </div>
    </div>
  `;
        _workingElement.innerHTML = innerMarkup;
        const inputs = document.querySelectorAll("input[type=checkbox]");
        for (let i = 0; i < inputs.length; i++) {
          inputs[i].addEventListener("change", setSelection);
        }
      };
      function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
                if (parts.length === 2)
                    return parts.pop().split(";").shift();
      }
      var getCookies = () => {
        const pairs = document.cookie.split(";");
        let cookies = {};
        for (let i = 0; i < pairs.length; i++) {
          let pair = pairs[i].split("=");
          cookies[(pair[0] + "").trim()] = unescape(pair.slice(1).join("="));
        }
        return cookies;
      };
      var setCookie = (name, value) => {
        const d = new Date();
        d.setTime(d.getTime() + 24 * 60 * 60 * 1e3 * 365);
                document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
      };
      var setSelection = (e) => {
        const type = e.target.name.split("-")[1];
        _choices[type] = e.target.checked;
      };
      var setConsentCategories = (forced = false) => {
        _args.categories.map((c) => {
          if (c.type == "required" || forced) {
            _choices[c.type] = true;
          } else {
            _choices[c.type] = false;
          }
        });
      };
      var checkForConsent = () => {
        const cookies = getCookies();
        Object.keys(cookies).map((cookie) => {
          _choices[cookie] = cookies[cookie];
        });
        if (getCookie("_consent") == "true") {
          _consentGiven = true;
        } else {
          setCookie("_consent", false);
          _consentGiven = false;
        }
      };
      var setConsent = () => {
        Object.keys(_choices).forEach((choice) => {
          setCookie(choice, _choices[choice]);
        });
        setCookie("_consent", true);
        window.location.reload();
      };
      var setDefault = () => {
        setConsentCategories(true);
        setConsent();
      };
      var bindButtons = () => {
        const acceptButton = document.getElementById("btnAcceptDefault");
        const customizeButton = document.getElementById("btnCustomizeConsent");
        acceptButton.addEventListener("click", function (e) {
          setDefault();
        });
        customizeButton.addEventListener("click", function (e) {
          customizeConsent();
          const saveCustom = document.getElementById("btnSaveCustom");
          const customAcceptButton = document.getElementById("btnCustomAcceptDefault");
          saveCustom.addEventListener("click", function (e2) {
            setConsent();
          });
          customAcceptButton.addEventListener("click", function (e2) {
            setDefault();
          });
        });
      };
      var mergeTexts = (target, source) => {
        return Object.keys(source).reduce((prev, key) => {
          if (typeof source[key] === "string") {
            prev[key] = source[key] !== "" ? source[key] : target[key];
          } else {
            prev[key] = Object.assign({}, target[key] || {}, source[key]);
          }

          return prev;
        }, Object.assign({}, target));
      };
      var updateCookieSettings = () => {
        createWorkingElement();
        populatePopup();
        bindButtons();
      };
      var init = (args) => {
        _args = args;
        if (_args.text) {
          _text = mergeTexts(import_texts.default, _args.text);
        }
        setConsentCategories();
        checkForConsent();
        if (!_consentGiven) {
          createWorkingElement();
          populatePopup();
          bindButtons();
        }
      };
      module.exports = {
        init,
        updateCookieSettings
      };
    }
  });
  return require_src();
})();
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./Components/Shared/cookieconsent.js